import { Header } from "./Typography.Header";
import { HeaderNumber } from "./Typography.HeaderNumber";
import { Link } from "./Typography.Link";
import { Text } from "./Typography.Text";
const Typography = {
  Header,
  HeaderNumber,
  Link,
  Text
};
export { Typography };
//# sourceMappingURL=Typography.mjs.map
